export default __webpack_public_path__ + "static/media/effect-2048.f9daeada.mp3";